import * as React from 'react';
import { InlineChildren, StackChildren } from '@doordash/design-language';
import { QuestionSectionContainer } from '../QuizStyles';
import { OptionTile } from './OptionTile';
export var OptionsSelectionSection = function (_a) {
    var isMobile = _a.isMobile, options = _a.options, selectedOption = _a.selectedOption, onOptionSelected = _a.onOptionSelected;
    var AlignChildrenContainer = isMobile ? StackChildren : InlineChildren;
    return (React.createElement(QuestionSectionContainer, null,
        React.createElement(AlignChildrenContainer, null, options.map(function (option) { return (React.createElement(OptionTile, { key: option.id, isSelected: selectedOption === option.id, id: option.id, title: option.title, subtitle: option.subtitle, imageUrl: option.url, onSelect: onOptionSelected })); }))));
};
